import { pageGutter } from '../../../pages/Page/props';

export const uiBody = {
  p: `${pageGutter}px`,
};
